/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontFeaturedSection_seller = {
    readonly sellerPreferences: {
        readonly urlLabel: string | null;
    } | null;
    readonly " $refType": "StorefrontFeaturedSection_seller";
};
export type StorefrontFeaturedSection_seller$data = StorefrontFeaturedSection_seller;
export type StorefrontFeaturedSection_seller$key = {
    readonly " $data"?: StorefrontFeaturedSection_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_seller">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontFeaturedSection_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "kind": "LinkedField",
      "name": "sellerPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = 'bc08d8a399155d5520d7651d9b726063';
export default node;
